export class DoughnutChartGMBModel {
  constructor() {
    this.chart = null;
    this._chartConfig = null;
  }

  makeChart(chartConfig) {
    this._setChartConfig(chartConfig);
    this._setChartConfigAsChart();
    this._setChartData();
    this._setChartOptions();
    this._setChartSum();
    this._setChartPercentage();
    this._setChartLabelsText();
  }

  returnChart() {
    return this.chart;
  }

  _setChartConfig(chartConfig) {
    this._chartConfig = chartConfig;
  }

  _setChartConfigAsChart() {
    this.chart = this._chartConfig;
  }

  _setChartData() {
    this.chart.data = this.chart.relatedChartsData.map(relatedChartData =>
      relatedChartData.values
        .map(values => values.y)
        .flat()
        .reduce((a, b) => a + b, 0)
    );
  }
  _formatNumber(value) {
    if (typeof value === "string" || value instanceof String) return value;
    return new Intl.NumberFormat("fr-FR").format(value);
  }
  _setChartOptions() {
    const vm = this;
    this.chart.options = {
      tooltips: {
        callbacks: {
          title: function(tooltipItem, data) {
            return data["labels"][tooltipItem[0]["index"]];
          },
          label: function(tooltipItem, data) {
            return vm._formatNumber(
              data["datasets"][0]["data"][tooltipItem["index"]]
            );
          }
        }
      }
    };
  }

  _setChartSum() {
    this.chart.sum = this.chart.relatedChartsData
      .map(relatedChartData => relatedChartData.sum)
      .reduce((a, b) => a + b, 0)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

  _setChartPercentage() {
    const chartsPercentage = this.chart.relatedChartsData
      .map(relatedChartData => relatedChartData.periodPercentageDiff)
      .filter(percentage => typeof percentage !== "undefined");

    this.chart.percentage =
      chartsPercentage.length > 0
        ? Math.round(
            chartsPercentage.reduce((a, b) => a + b, 0) /
              this.chart.relatedChartsData.length
          )
        : null;
  }

  _setChartLabelsText() {
    if (this.chart.labels.length > 0) {
      this.chart.labelsText = this.chart.labels.map(label => label.text);
    }
  }
}
